import { render, staticRenderFns } from "./Tlmkt2.vue?vue&type=template&id=15762796"
import script from "./Tlmkt2.vue?vue&type=script&lang=js"
export * from "./Tlmkt2.vue?vue&type=script&lang=js"
import style0 from "./Tlmkt2.vue?vue&type=style&index=0&id=15762796&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports